import { create } from "zustand";
import type { User } from "../types";

interface UsersState {
	modalOpen: boolean;
	editingUser: User | null;
}

interface UsersActions {
	openCreateModal: () => void;
	openEditModal: (user: User) => void;
	onOpen: (user?: User) => void;
	closeModal: () => void;
}

type UsersStore = UsersState & UsersActions;

export const useUsersStore = create<UsersStore>((set) => ({
	modalOpen: false,
	editingUser: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingUser: null });
	},

	openEditModal: (user) => {
		set({ modalOpen: true, editingUser: user });
	},

	onOpen: (user) => {
		set({ modalOpen: true, editingUser: user ?? null });
	},

	closeModal: () => {
		set({ modalOpen: false, editingUser: null });
	},
}));
